import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Analytics } from "@vercel/analytics/react";
import { SpeedInsights } from "@vercel/speed-insights/react";
import { AuthProvider } from "@/contexts/AuthContext";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import { RouteErrorBoundary } from "@/components/RouteErrorBoundary";
import EscolherConta from "./pages/consumer/EscolherConta";
import ConsumerHome from "./pages/consumer/ConsumerHome";
import ConsumerConversas from "./pages/consumer/ConsumerConversas";
import ConsumerChat from "./pages/consumer/ConsumerChat";
import ConsumerPerfil from "./pages/consumer/ConsumerPerfil";
import ConsumerServicos from "./pages/consumer/ConsumerServicos";
import ConsumerOSDetalhe from "./pages/consumer/ConsumerOSDetalhe";
import ConsumerPedidos from "./pages/consumer/ConsumerPedidos";
import ConsumerPedidoNovo from "./pages/consumer/ConsumerPedidoNovo";
import ConsumerPedidoDetalhe from "./pages/consumer/ConsumerPedidoDetalhe";
import { ConsumerProtectedRoute } from "@/components/consumer/ConsumerProtectedRoute";
import Painel from "./pages/Painel";
import Clientes from "./pages/Clientes";
import ClientePotential from "./pages/ClientePotential";
import ClienteParaPrestador from "./pages/ClienteParaPrestador";
import Configuracoes from "./pages/Configuracoes";
import ConfiguracoesPlano from "./pages/ConfiguracoesPlano";
import Dashboard from "./pages/Dashboard";
import OrdensServico from "./pages/OrdensServico";
import OrdemServicoDetalhes from "./pages/OrdemServicoDetalhes";
import Equipe from "./pages/Equipe";
import VisualizarPrestador from "./pages/VisualizarPrestador";
import MeusServicos from "./pages/MeusServicos";
import MinhaAgenda from "./pages/MinhaAgenda";
import MeuPerfil from "./pages/MeuPerfil";
import ConfiguracoesPrestador from "./pages/ConfiguracoesPrestador";
import Auth from "./pages/Auth";
import ContaDesativada from "./pages/ContaDesativada";
import Onboarding from "./pages/Onboarding";
import NotFound from "./pages/NotFound";
import Landing from "@/pages/Landing";
import Privacidade from "./pages/Privacidade";
import AceitarConvite from "./pages/AceitarConvite";
 import Servicos from "./pages/Servicos";
import Agenda from "./pages/Agenda";
import Recorrencias from "./pages/Recorrencias";
import Solicitacoes from "./pages/Solicitacoes";
import Empresas from "./pages/Empresas";
import EmpresaPublica from "./pages/EmpresaPublica";
const queryClient = new QueryClient();

const App = () => (
  <QueryClientProvider client={queryClient}>
    <TooltipProvider>
      <AuthProvider>
        <Toaster />
        <Sonner />
        <Analytics />
        <SpeedInsights />
        <BrowserRouter>
          <Routes>
            <Route path="/" element={
              <RouteErrorBoundary>
                <Landing />
              </RouteErrorBoundary>
            } />
            <Route path="/privacidade" element={
              <RouteErrorBoundary>
                <Privacidade />
              </RouteErrorBoundary>
            } />
            <Route path="/aceitar-convite/:token" element={
              <RouteErrorBoundary>
                <AceitarConvite />
              </RouteErrorBoundary>
            } />
            <Route path="/auth" element={
              <RouteErrorBoundary>
                <Auth />
              </RouteErrorBoundary>
            } />
            <Route path="/conta-desativada" element={
              <RouteErrorBoundary>
                <ContaDesativada />
              </RouteErrorBoundary>
            } />

            <Route path="/painel" element={
              <ProtectedRoute blockPrestador>
                <RouteErrorBoundary>
                  <Painel />
                </RouteErrorBoundary>
              </ProtectedRoute>
            } />
            <Route path="/clientes" element={
              <ProtectedRoute blockPrestador>
                <RouteErrorBoundary>
                  <Clientes />
                </RouteErrorBoundary>
              </ProtectedRoute>
            } />
            <Route path="/dashboard" element={
              <ProtectedRoute blockPrestador>
                <RouteErrorBoundary>
                  <Dashboard />
                </RouteErrorBoundary>
              </ProtectedRoute>
            } />
            <Route path="/ordens" element={
              <ProtectedRoute blockPrestador>
                <RouteErrorBoundary>
                  <OrdensServico />
                </RouteErrorBoundary>
              </ProtectedRoute>
            } />
            <Route path="/agenda" element={
              <ProtectedRoute blockPrestador>
                <RouteErrorBoundary>
                  <Agenda />
                </RouteErrorBoundary>
              </ProtectedRoute>
            } />
            <Route path="/recorrencias" element={
              <ProtectedRoute blockPrestador>
                <RouteErrorBoundary>
                  <Recorrencias />
                </RouteErrorBoundary>
              </ProtectedRoute>
            } />
            <Route path="/solicitacoes" element={
              <ProtectedRoute blockPrestador>
                <RouteErrorBoundary>
                  <Solicitacoes />
                </RouteErrorBoundary>
              </ProtectedRoute>
            } />
            <Route path="/ordens/:id" element={
              <ProtectedRoute>
                <RouteErrorBoundary>
                  <OrdemServicoDetalhes />
                </RouteErrorBoundary>
              </ProtectedRoute>
            } />
            <Route path="/equipe" element={
              <ProtectedRoute requireAdmin>
                <RouteErrorBoundary>
                  <Equipe />
                </RouteErrorBoundary>
              </ProtectedRoute>
            } />
            <Route path="/equipe/prestador/:id" element={
              <ProtectedRoute requireAdmin>
                <RouteErrorBoundary>
                  <VisualizarPrestador />
                </RouteErrorBoundary>
              </ProtectedRoute>
            } />
             <Route path="/servicos" element={
               <ProtectedRoute requireAdmin>
                 <RouteErrorBoundary>
                   <Servicos />
                 </RouteErrorBoundary>
               </ProtectedRoute>
             } />
            <Route path="/meus-servicos" element={
              <ProtectedRoute>
                <RouteErrorBoundary>
                  <MeusServicos />
                </RouteErrorBoundary>
              </ProtectedRoute>
            } />
            <Route path="/minha-agenda" element={
              <ProtectedRoute>
                <RouteErrorBoundary>
                  <MinhaAgenda />
                </RouteErrorBoundary>
              </ProtectedRoute>
            } />
            <Route path="/meu-perfil" element={
              <ProtectedRoute>
                <RouteErrorBoundary>
                  <MeuPerfil />
                </RouteErrorBoundary>
              </ProtectedRoute>
            } />
            <Route path="/configuracoes-prestador" element={
              <ProtectedRoute>
                <RouteErrorBoundary>
                  <ConfiguracoesPrestador />
                </RouteErrorBoundary>
              </ProtectedRoute>
            } />
            {/* Página de cliente para admin/atendente */}
            <Route path="/cliente-potential/:id" element={
              <ProtectedRoute blockPrestador>
                <RouteErrorBoundary>
                  <ClientePotential />
                </RouteErrorBoundary>
              </ProtectedRoute>
            } />
            {/* Página de cliente para prestadores (dados básicos apenas) */}
            <Route path="/cliente/:id" element={
              <ProtectedRoute>
                <RouteErrorBoundary>
                  <ClienteParaPrestador />
                </RouteErrorBoundary>
              </ProtectedRoute>
            } />
            <Route path="/configuracoes" element={
              <ProtectedRoute requireAdmin>
                <RouteErrorBoundary>
                  <Configuracoes />
                </RouteErrorBoundary>
              </ProtectedRoute>
            } />
            <Route path="/configuracoes/plano" element={
              <ProtectedRoute requireAdmin>
                <RouteErrorBoundary>
                  <ConfiguracoesPlano />
                </RouteErrorBoundary>
              </ProtectedRoute>
            } />
            <Route path="/onboarding" element={
              <RouteErrorBoundary>
                <Onboarding />
              </RouteErrorBoundary>
            } />
            {/* ── Área do cliente (marketplace SP0) ── */}
            <Route path="/conta/escolher" element={
              <RouteErrorBoundary><EscolherConta /></RouteErrorBoundary>
            } />
            <Route path="/app" element={
              <ConsumerProtectedRoute>
                <RouteErrorBoundary><ConsumerHome /></RouteErrorBoundary>
              </ConsumerProtectedRoute>
            } />
            <Route path="/app/conversas" element={
              <ConsumerProtectedRoute>
                <RouteErrorBoundary><ConsumerConversas /></RouteErrorBoundary>
              </ConsumerProtectedRoute>
            } />
            <Route path="/app/conversas/:clienteId" element={
              <ConsumerProtectedRoute>
                <RouteErrorBoundary><ConsumerChat /></RouteErrorBoundary>
              </ConsumerProtectedRoute>
            } />
            <Route path="/app/servicos" element={
              <ConsumerProtectedRoute>
                <RouteErrorBoundary><ConsumerServicos /></RouteErrorBoundary>
              </ConsumerProtectedRoute>
            } />
            <Route path="/app/servicos/:osId" element={
              <ConsumerProtectedRoute>
                <RouteErrorBoundary><ConsumerOSDetalhe /></RouteErrorBoundary>
              </ConsumerProtectedRoute>
            } />
            <Route path="/app/pedidos" element={
              <ConsumerProtectedRoute>
                <RouteErrorBoundary><ConsumerPedidos /></RouteErrorBoundary>
              </ConsumerProtectedRoute>
            } />
            <Route path="/app/pedidos/novo" element={
              <ConsumerProtectedRoute>
                <RouteErrorBoundary><ConsumerPedidoNovo /></RouteErrorBoundary>
              </ConsumerProtectedRoute>
            } />
            <Route path="/app/pedidos/:id" element={
              <ConsumerProtectedRoute>
                <RouteErrorBoundary><ConsumerPedidoDetalhe /></RouteErrorBoundary>
              </ConsumerProtectedRoute>
            } />
            <Route path="/app/perfil" element={
              <ConsumerProtectedRoute>
                <RouteErrorBoundary><ConsumerPerfil /></RouteErrorBoundary>
              </ConsumerProtectedRoute>
            } />
            <Route path="/empresas" element={<RouteErrorBoundary><Empresas /></RouteErrorBoundary>} />
            <Route path="/empresas/:id" element={<RouteErrorBoundary><EmpresaPublica /></RouteErrorBoundary>} />
            <Route path="*" element={
              <RouteErrorBoundary>
                <NotFound />
              </RouteErrorBoundary>
            } />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </TooltipProvider>
  </QueryClientProvider>
);

export default App;
